import { ResourceCategoryType as ResourceCategoryTypeEnum } from '@mews-commander/data-access';
import { enumify, Enumify } from '@mews/enumify';

function ResourceCategoryType() {}

enumify<ResourceCategoryTypeEnum, number>(ResourceCategoryType, 'ResourceCategoryType', {
    Room: 0,
    Bed: 1,
    Dorm: 2,
    Apartment: 3,
    Suite: 4,
    Villa: 5,
    Site: 6,
    Office: 7,
    MeetingRoom: 8,
    ParkingSpot: 9,
    Desk: 10,
    TeamArea: 11,
    Membership: 12,
    Tent: 13,
    CaravanOrRV: 14,
    UnequippedCampsite: 15,
    Bike: 16,
    ExtraBed: 17,
    Cot: 18,
    Crib: 19,
    ConferenceRoom: 20,
    Rooftop: 21,
    Garden: 22,
    Restaurant: 23,
    Amphitheater: 24,
    PrivateSpaces: 25,
});

export default ResourceCategoryType as unknown as Enumify<ResourceCategoryTypeEnum, number>;
